module.exports = __webpack_public_path__ + "static/media/eye_closed.ba44e5af.svg";